import React from 'react'
import styled from 'styled-components'

const TitleContainer = styled.div`
  padding: 0 20px 0 20px;

  @media (max-width: 420px) {
    padding: 0 12px 0 12px;
  }
`

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: white;

  @media (max-width: 1024px) {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
  }

  @media (max-width: 420px) {
    font-size: 16px;
  }
`

const Subtitle = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #5f6886;
  text-align: center;

  @media (max-width: 1024px) {
    font-size: 12px;
  }

  @media (max-width: 768px) {
    font-size: 10px;
    width: auto;
  }
`

const HeaderTitle = ({title, subtitle}) => {
  return (
    <TitleContainer>
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </TitleContainer>
  )
}

export default HeaderTitle
